module.exports = __webpack_public_path__ + "img/main-ball-blue-line.af8b4b8a.png";